import { Pod } from '../store/slices/podsSlice';
import { Epic } from '../store/slices/epicsSlice';
import { Story } from '../store/slices/storiesSlice';
import { Category } from '../store/slices/categoriesSlice';
import { HealthWeightMap } from '../store/slices/healthConfigSlice';
import { StatusMap } from '../store/slices/stateManagementSlice';
import { Workstream } from '../store/slices/workstreamsSlice';
import { WorkstreamSprint } from '../store/slices/sprintsSlice';
import {
  scenario1Pods,
  scenario1Categories,
  scenario1Epics,
  scenario1Stories,
  scenario1SprintForecastConfig,
  scenario1HealthConfig,
  scenario1SprintStateConfig,
  scenario1Workstreams,
  scenario1WorkstreamSprints,
} from './scenario1Data';

export interface ScenarioData {
  pods: Pod[];
  categories: Category[];
  epics: Epic[];
  stories: Story[];
  sprintSettings: { startDate: string; sprintLength: number; totalSprints: number };
  healthConfig: {
    epicWeights: HealthWeightMap;
    storyWeights: HealthWeightMap;
  };
  stateManagement: {
    epicStatuses: StatusMap;
    storyStatuses: StatusMap;
  };
  workstreams: Workstream[];
  /** Official sprints per workstream. Defaults to [] when absent. */
  workstreamSprints?: WorkstreamSprint[];
}

export interface DemoScenario {
  id: number;
  title: string;
  description: string;
  highlights: string[];
  /** null for the "Start from scratch" scenario — clears all data */
  data: ScenarioData | null;
}

export const demoScenarios: DemoScenario[] = [
  {
    id: 0,
    title: 'Scenario 0 – Start from Scratch',
    description:
      'Begin with a completely empty workspace. All pods, categories, epics, and stories will be cleared — ideal for building your own configuration from the ground up.',
    highlights: [
      'Empty workspace',
      'No pre-loaded data',
      'Sprint settings reset to defaults',
      'Health and status configuration reset to defaults',
    ],
    data: null,
  },
  {
    id: 1,
    title: 'Scenario 1 – Vehicle E-Commerce Retail',
    description:
      'A fully built-out demo for an online vehicle marketplace. Demonstrates a healthy, well-groomed backlog across three delivery pods with realistic epics, stories, comments, and sprint capacity planning.',
    highlights: [
      '3 pods: Storefront, Checkout & Payments, Inventory & Catalog',
      '36 epics with full story breakdowns',
      'Healthy backlog with rich acceptance criteria',
      'Pre-configured 10-sprint schedule',
      'Story comments, reactions, and change history',
    ],
    data: {
      pods: scenario1Pods,
      categories: scenario1Categories,
      epics: scenario1Epics,
      stories: scenario1Stories,
      sprintSettings: scenario1SprintForecastConfig,
      healthConfig: scenario1HealthConfig,
      stateManagement: scenario1SprintStateConfig as { epicStatuses: StatusMap; storyStatuses: StatusMap; },
      workstreams: scenario1Workstreams,
      workstreamSprints: scenario1WorkstreamSprints,
    },
  },
];
